<script lang="ts">
  import type { Snippet } from 'svelte';
  import PulseLoader from './PulseLoader.svelte';

  /**
   * Over a section that keeps showing its old data while the new arrives (a query with
   * `keepPreviousData`): pass `isPlaceholderData`. Only this section softens; it stays readable,
   * scrollable and clickable, and the rest of the page does not know.
   */
  let { active, children }: { active: boolean; children?: Snippet } = $props();
</script>

<div class="relative" aria-busy={active || undefined}>
  {@render children?.()}
  {#if active}
    <div class="loading-veil"><PulseLoader small /></div>
  {/if}
</div>
